import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import "./AdminShared.css";

const AdminProductQuote = () => {
  const navigate = useNavigate();
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(null);

  const fetchQuotes = async () => {
    const adminInfo = JSON.parse(localStorage.getItem("adminInfo") || "{}");
    const token = adminInfo?.token;

    const response = await fetch(`${API_BASE_URL}/api/quotes`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error("Failed to synchronize commerce data");
    return response.json();
  };

  const loadQuotes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await fetchQuotes();
      setQuotes(Array.isArray(data) ? data.reverse() : []);
    } catch (err) {
      console.error(err);
      setQuotes([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("adminInfo");
    if (!token) return navigate("/admin");
    loadQuotes();
  }, [loadQuotes, navigate]);

  const deleteQuote = async (id) => {
    if (!window.confirm("Purge this commercial inquiry?")) return;
    setDeleting(id);
    try {
      const adminInfo = JSON.parse(localStorage.getItem("adminInfo") || "{}");
      const token = adminInfo?.token;
      const response = await fetch(`${API_BASE_URL}/api/quotes/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) setQuotes((prev) => prev.filter((q) => q._id !== id));
    } catch (err) {
      alert(`Deletion failed: ${err.message}`);
    } finally {
      setDeleting(null);
    }
  };

  if (loading) return (
    <div className="admin-list-container">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh', gap: '20px' }}>
            <div className="loading-spinner"></div>
            <p style={{ fontWeight: 700, color: '#475569' }}>⏳ Synchronizing Commerce Pipeline...</p>
        </div>
    </div>
  );

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Quote Management</h1>
        </div>
        <button className="module-badge" style={{ cursor: 'pointer', background: '#eab308', border: 'none' }} onClick={loadQuotes}>
          Sync Pipeline 🔄
        </button>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#eab308' }}></div>
            Operator: Global Commerce Node
          </div>
          <div className="admin-status-badge" style={{ background: '#fef9c3', color: '#854d0e', fontSize: '0.75rem', fontWeight: 800 }}>
             {quotes.length} PENDING INQUIRIES
          </div>
        </div>

        <div className="admin-table-wrapper">
          <table className="elite-table">
            <thead>
              <tr>
                <th>Customer Profile</th>
                <th>Asset Identity</th>
                <th>Corporate Intel</th>
                <th>Logistics Node</th>
                <th>Enquiry Fragment</th>
                <th>Operations</th>
              </tr>
            </thead>
            <tbody>
              {quotes.length === 0 ? (
                <tr>
                   <td colSpan="6" style={{ textAlign: 'center', padding: '100px', color: '#94a3b8' }}>
                        No commercial inquiries detected in the current buffer.
                   </td>
                </tr>
              ) : (
                quotes.map((q) => (
                  <tr key={q._id}>
                    <td>
                      <div style={{ fontWeight: 700 }}>{q.name}</div>
                      <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{q.phone}</div>
                    </td>
                    <td>
                      <div style={{ fontWeight: 700, color: '#eab308' }}>{q.product}</div>
                      <div style={{ fontSize: '0.75rem', fontWeight: 700 }}>QTY: {q.quantity}</div>
                    </td>
                    <td>
                        <div style={{ fontWeight: 600 }}>{q.company || "Retail Inquiry"}</div>
                        <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>ENTITY-ID</div>
                    </td>
                    <td>
                        <div style={{ fontWeight: 600 }}>{q.location}</div>
                        <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>DELIVERY-NODE</div>
                    </td>
                    <td>
                        <div style={{ fontSize: '0.85rem', color: '#475569', maxWidth: '250px', whiteSpace: 'normal' }}>
                            {q.message || "No supplemental fragments."}
                        </div>
                    </td>
                    <td>
                      <button className="action-btn-elite btn-delete" onClick={() => deleteQuote(q._id)} disabled={deleting === q._id}>
                        {deleting === q._id ? "..." : <span>🗑️</span>}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminProductQuote;
